import { createObjectStorage, Storage, ObjectStorage } from 'infra/storage'

export interface LastWorkspace {
  [key: string]: string
}

export class LastWorkspaceStorage {
  private readonly key = 'lastWorkspaceByUser'
  private readonly storage: ObjectStorage

  constructor(storage: Storage) {
    this.storage = createObjectStorage(storage)
  }

  load = (userId: string) => {
    const item = this.storage.getItem(this.key)
    return item ? (item as LastWorkspace)[userId] : null
  }

  save = (workspaceId: string, userId: string) => {
    const lastWorkspace = { [userId]: workspaceId } as LastWorkspace
    const current = this.storage.getItem(this.key)

    if (!current) {
      this.storage.setItem(this.key, lastWorkspace)
      return
    }

    const updated = {
      ...(current as LastWorkspace),
      ...lastWorkspace,
    } as LastWorkspace

    this.storage.setItem(this.key, updated)
  }
}
